import { BdaDataset } from "./BdaDataset";
import { BdaModel } from "./BdaModel";
import { WorkflowStatusModel } from "./Workflow";
import { AccessLevel } from "./generics";
import { Organization, Owner } from "./ControlPanel";
import { Note } from "./BdaApplication";

export type ServiceMode = 'BATCH' | 'SOURCE' | 'PROCESSOR' | 'SINK';

export class BdaService {
  accessLevel?: AccessLevel;
  category?: ServiceCategory;
  // TODO remove this;
  // area?: string;
  description: string;
  id?: number;
  label?: string;
  metrics?: any[]; // TODO improve type
  mode: ServiceMode;
  models?: BdaModel[];
  name: string;
  organization?: Organization;
  owner?: Owner;
  properties: BdaServiceProperty[];
  ref?: string;
  statusModel?: WorkflowStatusModel;
  tags: string[];
  url: string;
  version: string;
  notes?: Note[];
  markDown?: {
    value: string;
  }

  constructor() {
    this.name = '';
    this.description = '';
    this.mode = 'BATCH';
    this.version = "";
    this.properties = [];
    this.url = '';
    this.tags = [];
  }
}

export class AssetDetails {
  name?: string;
  path?: string;
  type?: string;
  description?: string;
  from?: string;
}

export class AssetsPropertyValue {
  inputs?: AssetDetails[];
  outputs?: AssetDetails[];
}

export class BdaServiceProperty {
  id?: number;
  defaultValue: any;
  description: string;
  invisible: boolean;
  key: string;
  mandatory: boolean;
  type: 'application' | 'tuning' | 'static' | 'resource';
  valueType: 'STRING' | 'BOOLEAN' | 'INT' | 'DOUBLE' | 'JSON';
  value: any;
  dataset?: Partial<BdaDataset>;
  model?: Partial<BdaModel>;
  extra?: any; // datasetType, mode
  interpolationEnabled?: boolean;

  constructor(type: 'application' | 'tuning' | 'static' | 'resource') {
    this.defaultValue = null;
    this.description = "";
    this.invisible = false;
    this.key = "";
    this.mandatory = false;
    this.type = type;
    this.valueType = "STRING";
  }
}

export class BdaServiceApplicationProperty extends BdaServiceProperty {
  inputData: boolean;
  outputData: boolean;
  obfuscated: boolean;

  constructor() {
    super('application');
    this.inputData = false;
    this.outputData = false;
    this.obfuscated = false;
  }
}

export class BdaServiceTuningProperty extends BdaServiceProperty {
  maxValue: string;
  minValue: string;
  measure: string;
  mappings: TuningPropertyMapping[];
  category: boolean;

  constructor() {
    super("tuning");
    this.maxValue = "";
    this.minValue = "";
    this.measure = "";
    this.mappings = [];
    this.category = false;
    // this.numberOfReplicas = 0;
  }
}

export class BdaServiceResourceProperty extends BdaServiceProperty {
  allowedRange?: { min: number, max: number };
  metricUnit?: string;
  step?: number;

  constructor() {
    super('resource');
  }
}

export class BdaServiceStaticProperty extends BdaServiceProperty {
  externalized: boolean;
  uri: string;

  constructor() {
    super("static");
    this.externalized = false;
    this.uri = "";
  }
}

export interface TuningPropertyMapping {
  name: string;
  intValue: string | number;
}

export interface ServiceCategory {
  id?: number;
  name: string;
  children?: ServiceCategory[];
}